"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./AccountsApi"), exports);
__exportStar(require("./AdminApi"), exports);
__exportStar(require("./AdminCustomerContractsApi"), exports);
__exportStar(require("./AdminStaffApi"), exports);
__exportStar(require("./AdminUserApi"), exports);
__exportStar(require("./AzureApi"), exports);
__exportStar(require("./BranchApi"), exports);
__exportStar(require("./BranchProductApi"), exports);
__exportStar(require("./ClosureApi"), exports);
__exportStar(require("./ContentApi"), exports);
__exportStar(require("./DeliveryApi"), exports);
__exportStar(require("./EventsApi"), exports);
__exportStar(require("./InvoiceApi"), exports);
__exportStar(require("./LabelOrderApi"), exports);
__exportStar(require("./MetadataApi"), exports);
__exportStar(require("./OauthApi"), exports);
__exportStar(require("./OrderApi"), exports);
__exportStar(require("./PaymentApi"), exports);
__exportStar(require("./PricebookApi"), exports);
__exportStar(require("./ProductApi"), exports);
__exportStar(require("./ProductListsApi"), exports);
__exportStar(require("./ProstixAccountsApi"), exports);
__exportStar(require("./QuotesApi"), exports);
__exportStar(require("./RegisterApi"), exports);
__exportStar(require("./ReturnOrdersApi"), exports);
__exportStar(require("./ServerApi"), exports);
__exportStar(require("./ShareholdingApi"), exports);
__exportStar(require("./UserApi"), exports);
